import { NATIVE_ADDRESS, ZERO_ADDRESS } from '@shared/utils/config/networks';
import { LiaExchangeAltSolid } from 'react-icons/lia';
import { SelectionMode, TradeMode } from '@shared/types/frontend/trade';
import FromAssetsAmountSelection from '../swap-home/FromAssetsAmountSelection';
import SelectPercentage from './SelectPercentage';
import usePortfolioBalance from '@/hooks/portfolio/usePortfolioBalance';
import { useSwap } from '@/contexts/SwapProvider';
import BuySellAssetSelection from '@/components/asset/mobile/mobileBuySellAsset/BuySellAssetSelection';
import SwapAssetsSelection from '../swap-home/SwapAssetsSelection';
interface Props {
  tradeMode: TradeMode;
  showAmount: string;
  setShowAmount: (value: string) => void;
  isSwitched: boolean;
  setIsSwitched: (value: boolean) => void;
  setPercentage: (value: number) => void;
  disableInteraction?: boolean;
}
export default function SelectionScreen(p: Props) {
  const {
    setSelectFromAsset,
    setSelectToAsset,
    fromAssets,
    setFromAssets,
    toAssets,
    setToAssets
  } = useSwap();
  const {
    data: assetData
  } = usePortfolioBalance({});
  const toAssetsIsInBalance = () => {
    if (toAssets.length) {
      const toAssetAddress = toAssets[0].contract_address;
      const hasInBalance = assetData?.balances?.some(asset => {
        if (asset.contract_address === toAssetAddress && asset.network === toAssets[0].network) {
          return true;
        }
        if (toAssetAddress === ZERO_ADDRESS && asset.contract_address?.toLowerCase() == NATIVE_ADDRESS?.toLowerCase() && asset.network === toAssets[0].network) {
          return true;
        }
        return false;
      });
      if (hasInBalance) {
        return true;
      }
      return false;
    }
  };
  const allowSwapSwitch = toAssetsIsInBalance();
  function handleSwapSwitchAssets() {
    if (!fromAssets || !Array.isArray(fromAssets)) return;
    if (!toAssets || !Array.isArray(toAssets)) setToAssets([]);
    const userBalances = assetData.balances;
    let amountToUse = 0;
    let contract_ticker_symbol = null;
    const fromAssetInBalance = userBalances.find(balance => balance.contract_address === toAssets[0].contract_address && balance.network === toAssets[0].network);
    if (toAssets.length && toAssets[0]) {
      userBalances.map((token: any) => {
        if (token.contract_address === toAssets[0].contract_address && token.network === toAssets[0].network) {
          amountToUse = token.usd_value;
          contract_ticker_symbol = token.contract_ticker_symbol;
        }
      });
      p.setShowAmount('0');
      setFromAssets([{
        ...fromAssetInBalance,
        amountToUseStr: '0',
        amountToUse: 0,
        usd_value: amountToUse,
        contract_ticker_symbol: contract_ticker_symbol
      }]);
    } else {
      setFromAssets([]);
    }
    if (fromAssets.length && fromAssets[0]) {
      setToAssets([fromAssets[0]]);
    } else {
      setToAssets([]);
    }
  }
  return <div className={`w-full flex flex-col gap-4 transition-opacity ${p.disableInteraction ? 'pointer-events-none opacity-50' : ''}`} data-sentry-component="SelectionScreen" data-sentry-source-file="SelectionScreen.tsx">
      <FromAssetsAmountSelection totalAmount={p.showAmount} asset={fromAssets[0]} isSwitched={p.isSwitched} setIsSwitched={p.setIsSwitched} enableSwitch={p.tradeMode === TradeMode.SWAP} data-sentry-element="FromAssetsAmountSelection" data-sentry-source-file="SelectionScreen.tsx" />

      <SelectPercentage setPercentage={p.setPercentage} data-sentry-element="SelectPercentage" data-sentry-source-file="SelectionScreen.tsx" />

      {p.tradeMode === TradeMode.SWAP ? <div className={'relative w-full flex justify-center items-center gap-2 px-4'}>
          <SwapAssetsSelection mode={SelectionMode.FROM} setSelectAsset={setSelectFromAsset} assets={fromAssets} />

          <div onClick={() => allowSwapSwitch && handleSwapSwitchAssets()} className={`w-[28px] h-[28px] min-w-[28px] min-h-[28px] border-genius-blue border-[1px] rounded-full flex items-center justify-center text-genius-cream ${!allowSwapSwitch ? 'opacity-50 pointer-events-none' : ''}`}>
            <LiaExchangeAltSolid />
          </div>

          <SwapAssetsSelection mode={SelectionMode.TO} setSelectAsset={setSelectToAsset} assets={toAssets} />
        </div> : <BuySellAssetSelection tradeMode={p.tradeMode} asset={p.tradeMode === TradeMode.BUY ? fromAssets[0] : toAssets[0]} showSelectionsModal={() => p.tradeMode === TradeMode.BUY ? setSelectFromAsset(true) : setSelectToAsset(true)} />}
    </div>;
}